import React from "react";
import { useTranslation } from "react-i18next";
import TrashIcon from "../../../assets/icons/Trash.svg";
import * as moment from 'moment';
import { useLocation } from "react-router-dom";
import { useDispatch } from "react-redux";
import { playSong } from "../../common/actions/common.actions";
import { FaLocationArrow } from "react-icons/fa";


const Content = ({ eventTime, homeTeam, awayTeam, bodyHandicap, goalHandicap, match, sendDataToParent, selectedMatches = [], fromSelectedPage = false, handleRemoveCard, isFivePercent, flag }) => {

    const { t, i18n } = useTranslation();
    const dispatch = useDispatch();
    const location = useLocation();

    const handleSongClick = async () => {
        dispatch(playSong());
    };

    const handleClick = (choosen) => {
        handleSongClick();
        sendDataToParent(choosen, match);
    };

    const isSelected = selectedMatches?.some(
        (x) => x.eventId === match.eventId
    );

    // Determine if the match is selected and chosen as 'home'
    const isHomeChosen =
        isSelected && selectedMatches?.some((x) => x.eventId === match.eventId && x.choosen === "home");

    // Determine if the match is selected and chosen as 'away'
    const isAwayChosen =
        isSelected && selectedMatches?.some((x) => x.eventId === match.eventId && x.choosen === "away");

    // Determine if the match is selected and chosen as 'over'
    const isOverChosen =
        isSelected && selectedMatches?.some((x) => x.eventId === match.eventId && x.choosen === "over");

    // Determine if the match is selected and chosen as 'under'
    const isUnderChosen =
        isSelected && selectedMatches?.some((x) => x.eventId === match.eventId && x.choosen === "under");

    const removeCard = async () => {
        await handleSongClick();
        handleRemoveCard(match.rapidEventId);
    }

    return (
        <li className={`w-[98%] rounded-full border-slate-300 font-myanmarSansPro  my-1 ${location.pathname === '/body'}`}>
            {/* Card ရဲ့ Border Color      နဲ့ ==========    Card ရဲ့ BgColor  */}
            <div className={`flex justify-between items-center mb-1 text-league_text `}>

                {fromSelectedPage ? (
                    <img src={TrashIcon} alt="" onClick={removeCard} className=" cursor-pointer" />
                ) : (
                    <div className={`${flag === match.leagueName ? 'hidden' : 'flex'} items-center px-2 py-1 rounded-full  ${location.pathname === '/body'}`}>
                        {/* Leagues ရဲ့ BgColor*/}
                        <FaLocationArrow size={10} className="text-waterTitle" />
                        <p className={`ml-2 text-xs font-bold  text-waterTitle ${location.pathname === '/body' && (isFivePercent ? ' text-waterTitle' : '')}`}>
                            {/* Leagues ရဲ့ FgColor*/}
                            {match.leagueName}
                        </p>
                    </div>
                )}
            </div>
            <div className={`flex flex-col rounded-md ${location.pathname === '/body' && (isFivePercent ? 'bg-slate-300' : 'bg-slate-100')} ${location.pathname !== '/body' && ('bg-slate-300')} p-2`}>
                <p className="text-left w-fit whitespace-nowrap font-bold font-inter text-xs md:text-sm  text-waterThree rounded-full p-1">
                    {/* DateTime ရဲ့ Color*/}
                    {moment(new Date(match?.eventTime)).format("DD.MM.YYYY h:mm A")}
                </p>
                <div
                    className={`grid grid-cols-2 gap-1 mb-1 ${fromSelectedPage ? " pointer-events-none" : ""
                        }`}
                >
                    <div
                        onClick={() => handleClick("home")}
                        className={`${isHomeChosen ? "bg-gradient-to-r from-waterThree via-waterThree to-waterTwo " : "bg-wback"
                            } cursor-pointer rounded-full py-[10px] px-1 flex items-center text-center justify-center`}
                    >
                        {/* HomeTeams ရဲ့ Selection BgColor*/}
                        <h3
                            className={`ml-auto font-bold  ${isHomeChosen ? "text-white" : ""
                                } text-sm sm:text-base md:text-base flex flex-1 justify-center`}
                        >
                            {/* HomeTeams ရဲ့ Selection FgColor*/}
                            {i18n.language === "en" ? match.homeTeam : match.homeTeamMyan}
                        </h3>
                        {match.overId === match.homeId && (
                            <h3 className="bg-waterFour p-1 font-mono rounded-full ml-auto font-bold text-wback text-xxs text-xs sm:text-sm md:text-base">
                                {/* HomeTeams ဘက်က ကြေး FgColor*/}
                                {match.bodyHandicap}
                            </h3>
                        )}
                    </div>
                    <div
                        onClick={() => handleClick("away")}
                        className={`${isAwayChosen ? "bg-gradient-to-r from-waterTwo via-waterThree to-waterThree " : "bg-wback"
                            }
          cursor-pointer rounded-full py-[10px] px-1 flex items-center text-center justify-center`}

                    >
                        {/* AwayTeams ရဲ့ Selection BgColor*/}
                        {match.overId === match.awayId && (
                            <h3 className="bg-waterFour  whitespace-nowrap p-1 font-mono  font-bold rounded-full mr-auto text-wback text-xxs text-xs sm:text-sm md:text-base">
                                {/* AwayTeams ဘက်က ကြေး FgColor*/}
                                {match.bodyHandicap}
                            </h3>
                        )}
                        <h3
                            className={`font-bold text-football ${isAwayChosen ? "text-wback" : "text-wtext"
                                } dark:text-white text-sm sm:text-base md:text-base w-full`}
                        >
                            {/* AwayTeams ရဲ့ Selection FgColor*/}
                            {i18n.language === "en" ? match.awayTeam : match.awayTeamMyan}
                        </h3>
                    </div>
                </div>
                <div
                    className={`grid grid-cols-5 gap-1 ${fromSelectedPage ? "pointer-events-none" : ""
                        }`}
                >
                    <div
                        onClick={() => handleClick("over")}
                        className={`${isOverChosen ? "bg-gradient-to-r from-waterThree via-waterThree to-waterTwo" : "bg-wback"
                            }
          cursor-pointer rounded-full py-[7px] px-1 col-span-2`}
                    >
                        {/* GoalOver ရဲ့ Selection BgColor*/}
                        <h3
                            className={`font-bold text-center ${isOverChosen ? "text-wback" : "text-wtext"
                                } text-sm sm:text-sm md:text-base py-1`}
                        >
                            {/* GoalOver ရဲ့ Selection FgColor*/}
                            {t('goalOver')}
                        </h3>
                    </div>
                    <div className="cursor-not-allowed text-center bg-k_priceBgColor rounded-full p-1 flex justify-center items-center ">
                        {/* ဂိုးပေါင်းစျေး ရဲ့  BgColor*/}
                        <h3 className="font-mono text-center text-k_priceFgColor  font-bold text-xs sm:text-sm md:text-base">
                            {/* ဂိုးပေါင်းစျေး ရဲ့  FgColor*/}
                            {match.goalHandicap}
                        </h3>
                    </div>
                    <div
                        onClick={() => handleClick("under")}
                        className={`${isUnderChosen ? "bg-gradient-to-r from-waterTwo via-waterThree to-waterThree" : "bg-wback"
                            }
          cursor-pointer text-center rounded-full py-[7px] p-1 col-span-2 flex justify-center items-center`}
                    >
                        {/* GoalUnder ရဲ့ Selection BgColor*/}
                        <h3
                            className={`font-bold text-center ${isUnderChosen ? "text-wback" : "text-wtext"
                                } text-sm sm:text-sm md:text-base`}
                        >
                            {/* GoalUnder ရဲ့ Selection FgColor*/}
                            {t('goalUnder')}
                        </h3>
                    </div>
                </div>
            </div>
        </li >
    );
};

export default Content;
